import { render } from "./App.vue?vue&type=template&id=d287da6e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d287da6e&lang=css"

import exportComponent from "/Users/projects/crud/AVTO-SERVIS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__